import Enum from "../../../../../../enums/Enum";

const NatureEnum = new Enum({
    IMPROVING: {name: "Improving"},
    SAME: {name: "Same"},
    WORSENING: {name: "Worsening"}
});

export default NatureEnum;